import apiUtil from "@/util/apiUtil";
import type {DecisionSupportContext} from "./decisionSupport";

const BASE_URL = "/api/ActionPlan/decision-context";

export interface DecisionSupportContextRequest {
    insightTitle?: string;
    narrative?: string;
    aiNote?: string;
    headlineMetricValue?: string;
    headlineMetricLabel?: string;
    impactSummary?: string;
    actionTitle: string;
    actionDescription?: string;
    actionCategory?: string;
}

export async function generateDecisionContext(
    request: DecisionSupportContextRequest,
    signal?: AbortSignal
): Promise<DecisionSupportContext> {
    const result = await apiUtil.postData<{
        insight: string;
        action: string;
        goal: string;
    }>(BASE_URL, request, signal);

    return {
        insight: result.insight,
        action: result.action,
        goal: result.goal
    };
}
